<template>
    <div class="choose-item">
        <div class="choose-item-check">
            <span class="blank">
               {{itemContent.index}}
            </span>
        </div>
        <p class="item-content for-blank">
            <textarea id="" cols="30" rows="10" :placeholder="$t('fillInAnswer')" @blur="$emit('blank-input',{'content':blankInput,'index':itemIndex})" v-model="blankInput" :readonly='changeInput ? "readonly" : null '></textarea>
        </p>
    </div>
</template>

<script>
export default {
  name: 'BlankItem',
  data () {
    return {
      blankInput: '',
      changeInput: this.answerStatus,
      itemContent: this.content
    }
  },
  watch: {
    answerStatus (nv) {
      this.changeInput = nv
    },
    '$route' () {
      this.blankInput = ''
    }
  },
  created () {
    if (this.itemContent.answer) {
      this.blankInput = this.itemContent.answer
      this.changeInput = true
    }
  },
  props: [
    'content',
    'itemIndex',
    'answerStatus'
  ],
  methods: {

  }
}
</script>
<style lang="less"scoped>
.choose-item {
  cursor: pointer;
  // width: 94%;
  border: 1px solid #d9ddde;
  margin-bottom: 18px;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  display:flex;
  &:hover {
    background: #f6f6f6;
    .choose-item-check {
      span {
        i {
          display: block;
        }
      }
    }
  }
  &.choosed-be-true {
    border-color: #4aa854;
    border-width: 2px;
    .choose-item-check {
      span {
        i {
          display: block;
          background: #fff url(../../assets/img/true.png) no-repeat center/contain;
        }
      }
    }
    .item-content {
      border-color: #4aa854;
      border-width: 2px;
    }
  }
  &.choosed-be-false {
    border-color: #f75d5d;
    border-width: 2px;
    .choose-item-check {
      span {
        i {
          display: block;
          background: #fff url(../../assets/img/false.png) no-repeat center/contain;
        }
      }
    }
    .item-content {
      border-color: #f75d5d;
      border-width: 2px;
    }
  }
  &.unchoose-be-true {
    .choose-item-check {
      span {
        i {
          display: block;
          background: #fff url(../../assets/img/choose-true.png) no-repeat center/contain;
        }
      }
    }
  }
  &.unchoose-be-false {
    .choose-item-check {
      span {
        i {
          display: block;
          background: #fff url(../../assets/img/unchoose-false.png) no-repeat center/contain;
        }
      }
    }
  }
  &.item-choosed {
    border-color: #005587;
    border-width: 2px;
    .choose-item-check {
      span {
        i {
          display: block;
          background: #005587;
        }
      }
    }
    .item-content {
      border-color: #005587;
      border-width: 2px;
    }
  }
  .choose-item-check,
  .tf-item,
  .tf-choose-item {
    width: 8%;
    display:block;
    position: relative;
    &.for-true {
      border-left: 1px solid #d9dde0;
    }
    &.for-false {
      border-left: 1px solid #d9dde0;
    }
    &.result-true {
      span {
        i {
          display: block;
          background: #fff url(../../assets/img/true.png) no-repeat center/contain;
        }
      }
    }
    &.result-true-grey {
      span {
        i {
          display: block;
          background: #fff url(../../assets/img/choose-true.png) no-repeat center/contain;
        }
      }
    }
    &.result-false {
      span {
        i {
          display: block;
          background: #fff url(../../assets/img/false.png) no-repeat center/contain;
        }
      }
    }
    &.choosed {
      span {
        i {
          display: block;
          background: #005587;
        }
      }
    }
    span {
      display: block;
      width: 26px;
      height: 26px;
      border-radius: 14px;
      border: 1px solid #d9ddde;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -13px;
      margin-left: -13px;
      i {
        margin: 7px;
        display: none;
        width: 12px;
        height: 12px;
        border-radius: 9px;
        background: #9ca0a1;
        display: none;
        &.choosed {
          display: block;
        }
      }
      &.blank {
        text-align: center;
        line-height: 26px;
        border: 0;
        font-weight: bold;
        color: #262632;
      }
    }
  }
  .item-content {
    line-height: 24px;
    width: 92%;
    padding: 16px 50px 16px 20px;
    border-left: 1px solid #d9ddde;
    &.for-blank{
      padding:0;
      height:54px;
      textarea{
        display:block;
        width:100%;
        height:100%;
        visibility: visible;
        border:none;
        outline: none;
        box-sizing: border-box;
        padding:16px 20px;
        resize:none;
      }
    }
    &.for-tf{
      width:76%;
        // margin-left:58px;
    }
  }
    //多行判断新增
  &.tf-result-true{
    border-color:#4aa854;
    border-width:2px;
    .for-true,.for-false,.item-content{
      border-color:#4aa854;
    }
  }
  &.tf-result-false{
    border-color:#f75d5d;
    border-width:2px;
    .for-true,.for-false,.item-content{
      border-color:#f75d5d;
    }
  }
}
</style>
